import { Col, Row } from "react-bootstrap";
import "./styles.scoped.css";
import pliki from "../../jsondata/img_path.json";

interface PostProps {
  title: string;
  description: string;
  autor: string;
  image: number;
}

const Post: React.FC<PostProps> = (post: PostProps) => {
  return (
    <Row className="post">
        <Col sm={12} lg={5} className="photo">
            {pliki.map(
              (dane) =>
                post.image === dane.ID && (
                  <img
                    key={dane.ID}
                    src={`/images_photo/${dane.filename}`}
                    alt={dane.alt}
                    className="img"
                  />
                )
            )}
        </Col>
        <Col sm={12} lg={5} className="postbox">
          <Row>
            <h2 className="title">{post.title}</h2>
          </Row>
          <Row>
            {/* <p dangerouslySetInnerHTML={{ __html: post.description }} /> */}
            <p>{post.description.slice(0, 160)}...</p>
          </Row>
          
      </Col>
    </Row>
  );
};

export default Post;
